import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface FieldRefsStoreState {
  fieldRefs: Map<string, HTMLElement>;
}

/**
 * NOTE: this store deliberately holds a stable Map reference and is mutated
 * in place (see useRegisterFieldRef). It is NOT designed for use with selectors —
 * `useFieldRefsStore((s) => s.fieldRefs)` will never re-compute because the Map
 * reference never changes. Read only via the `getFieldRefs()` accessor in
 * event-handler-time code (e.g., on click).
 */
export const useFieldRefsStore = create<FieldRefsStoreState>()(
  devtools(() => ({ fieldRefs: new Map() }), { name: "FieldRefsStore" }),
);

export const getFieldRefs = (): Map<string, HTMLElement> => useFieldRefsStore.getState().fieldRefs;
